module.exports = __webpack_public_path__ + "img/SCC_Plasma.90239b70.png";